import { Container } from '@material-ui/core'
import styled from 'styled-components'
import FormContainer from '../../Form/FormContainer'
import CompanyInfo from './CompanyInfo'
import Notifications from './Notifications'
import PasswordInformation from './PasswordInformation'
import UserInfo from './UserInfo'

const MyAccount = styled(Container)`
  margin-bottom: 80px;

  .custom-tab {
    background: $color-gradient;
    display: flex;
    padding-bottom: 7px;
    margin: 33px 0 40px 0;

    .step,
    .spacer {
      background: $soft-white;
      position: relative;
      text-align: center;
      padding-top: 5px;
      padding-bottom: 8px;
      font-size: 0.75rem;
      font-weight: 600;
      color: #666666;
      padding-top: 3px;

      &:after {
        content: '';
        position: absolute;
        background: #f4f4f4;
        height: 4px;
        bottom: -4px;
        width: 100%;
        left: 0;
      }

      &.active {
        color: black;
        font-weight: bold;
        font-size: 0.875rem;
        padding-top: 0px;

        &:after {
          content: unset;
        }
      }
    }
  }
`
const Preferences = () => {
  return (
    <MyAccount>
      <FormContainer>
        <h3 className="page-title">My account</h3>
        <UserInfo />
        <CompanyInfo />
        <PasswordInformation />
        <Notifications />
      </FormContainer>
    </MyAccount>
  )
}

export default Preferences
